import { render, staticRenderFns } from "./Bruno.vue?vue&type=template&id=efbf424a&scoped=true&"
var script = {}
import style0 from "./Bruno.vue?vue&type=style&index=0&id=efbf424a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbf424a",
  null
  
)

export default component.exports